import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverAssignmentEntity } from '../../domain/entities/DriverAssignmentEntity'

export class DriverAssignmentModel extends DriverAssignmentEntity {
  constructor(dataDto: DriverAssignmentEntity) {
    super()
    mapEntityProperties<DriverAssignmentModel>(this, dataDto)
  }
}
